import { useQuery } from '@apollo/client';
import { logError } from 'fergy-core-react-logging';
import { type FunctionComponent, type PropsWithChildren, createContext, useEffect, useState } from 'react';
import type {
	GetFavoritedQuickStartsQueryVariables,
	GetFavoritedQuickStartsQuery
} from '../../../client/__generated__/graphql-client-types';
import { GET_FAVORITED_QUICKSTARTS } from '../../queries/project/project-quickstart.queries';

type QuickStartContextState = {
	favoritedQuickStarts: number[];
	setFavoritedQuickStarts: (favoritedQuickStarts: number[]) => void;
};

const initialState: QuickStartContextState = {
	favoritedQuickStarts: [],
	setFavoritedQuickStarts: () => {}
};

export const QuickStartContext = createContext<QuickStartContextState>(initialState);

export const QuickStartContextProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
	const { data, error } = useQuery<GetFavoritedQuickStartsQuery, GetFavoritedQuickStartsQueryVariables>(GET_FAVORITED_QUICKSTARTS, {
		variables: {
			input: {
				showingFavoriteLooks: true,
				paging: {
					pageSize: 999
				}
			}
		}
	});

	const [favoritedQuickStarts, setFavoritedQuickStarts] = useState<number[]>([]);
	useEffect(() => {
		const favoritedQuickStartsData = data?.discoverableQuickStarts?.quickStarts;
		if (favoritedQuickStartsData?.length && !favoritedQuickStarts.length) {
			setFavoritedQuickStarts(favoritedQuickStartsData.map((quickStart) => quickStart.projectId));
		}
		if (error) {
			logError(error);
		}
	}, [data, error]);

	return <QuickStartContext.Provider value={{ favoritedQuickStarts, setFavoritedQuickStarts }}>{children}</QuickStartContext.Provider>;
};
